/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Price related scripts

define('modules/Product/ProductPrice',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var isNew = false;
    var onSale = false;
    var bestSeller = false;
    var saleText = "Sale";
    function reloadProductPrice(viewModel) {
        //$('*[data-element-type="productTitle"]').html(viewModel.name);
        //Roc.UI.template('productPricingDetails-Tmp', viewModel.productPricing).then(function (renderedTemplate) {
        //    $('[data-roc-binding="pricing"]').html(renderedTemplate);
        //});
        if (viewModel.customFields.onSale && viewModel.customFields.onSale[0] && viewModel.customFields.onSale[0].value === true) {
            $("#isSaleItem").show();
            $("#isSaleItem").val(saleText);
        }
        else {
            $("#isSaleItem").hide();
        }

        if (viewModel.customFields.onSale && viewModel.customFields.isNew[0] && viewModel.customFields.isNew[0].value === true) {
            $("#isNewItem").show();
            $("#isNewItem").val(saleText);
        }
        else {
            $("#isNewItem").hide();
        }

        if (viewModel.customFields.bestSeller && viewModel.customFields.bestSeller[0] && viewModel.customFields.bestSeller[0].value === true) {
            $("#isBestSeller").show();
            $("#isBestSeller").val("BEST SELLER");
        }
        else {
            $("#isBestSeller").hide();
        }
    }

    function init(isnew, saletext, onsale, bestseller) {
        if (isnew) {
            isNew = isnew;
            if (isNew === 'True') {
                $("#isNewItem").show();
                $("#isNewItem").val("New");
            }
        }
        if (onsale) {
            onSale = onsale;
            if (onsale === 'True') {
                $("#isSaleItem").show();
                $("#isSaleItem").val("Sale");
            }
        }
        if (bestseller) {
            bestSeller = bestseller;
            if (bestseller === 'True') {
                $("#isBestSeller").show();
                $("#isBestSeller").val("BEST SELLER");
            }
        }
        if (saletext) {
            saleText = saletext;
        }
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductPrice);
    }

    var ProductPrice = {
        init: init
    }

    Roc.Logger.debug('ProductPrice.js Loaded:', ProductPrice);

    return ProductPrice;
});
